import React from 'react';
import { Box, Typography, List, ListItem, ListItemText } from '@mui/material';
import { PieChart, Pie, Cell } from 'recharts';
import './ClientBillingStatus.css';
import { useNavigate } from 'react-router-dom';
import { encodeQueryParam } from '../../utils/urlUtils';

const ClientBillingStatus = ({ totalclients, billingStatus, selectedUserId }) => {
  const navigate = useNavigate();
  const COLORS = ['#F54BB1', '#F4C107', '#03BC72'];

  const statusKeys = ['Past Due', 'Paused', 'Active'];

  const data = statusKeys.map((key, index) => ({
    name: key,
    value: billingStatus?.[key] ?? 0,
    color: COLORS[index],
  }));

  const handleFilterClick = (status) => {
    const formattedStatus = encodeQueryParam(status);
    const userIdParam = selectedUserId ? `&userId=${selectedUserId}` : '';
    navigate(`/clients?billingStatus=${formattedStatus}${userIdParam}`);
  };

  return (
    <Box className="cbs-container">
      <Typography variant="h6" className="cbs-title" sx={{ fontWeight: 700 }}>
        Billing Status
      </Typography>

      <Box className="cbs-inner-box">
        <Box className="cbs-pie-wrapper">
          <PieChart width={150} height={150}>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={70}
              fill="#8884d8"
              dataKey="value"
              stroke="none"
            >
              {data.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
          </PieChart>

          <Box className="cbs-center-text">
            <Typography variant="h4" fontWeight="bold">
              {totalclients ?? 0}
            </Typography>
            <Typography variant="body2">Clients</Typography>
          </Box>
        </Box>

        <List className="cbs-list">
          {data.map((item, index) => (
            <ListItem key={index} className="cbs-list-item"
            onClick={() => handleFilterClick(item.name)}
              sx={{
                cursor: 'pointer',
                userSelect: 'none',
                '&:hover': { backgroundColor: 'rgba(87, 42, 241, 0.1)', color: '#572AF1' },
              }}
              title={`Filter clients by billing status: ${item.name}`}
              >
              <Box className="cbs-dot" style={{ backgroundColor: item.color }} />
              <ListItemText
                primary={
                  <Typography component="span">
                    <strong>{item.value}</strong> {item.name}
                  </Typography>
                }
              />
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  );
};

export default ClientBillingStatus;
